<template>
    <!--添加/修改顾客-->
    <div>
        <pop-form :state="show" width="990px" body-max-height="670px">
            <template v-slot:title>{{title}}</template>
            <div class="edit-box">
                <el-form ref="editData" :model="editData" label-width="100px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="name" :rules='[
                            {required: true, message: "请填写姓名"},
                        ]'>
                                <el-input v-model="editData.name" placeholder="请输入会员姓名" @change="getUserNameSpell"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="手机号码" prop="mobile" :rules='[
                            {required: true, message: "请填写手机电话"},
                        ]'>
                                <el-input v-model="editData.mobile" placeholder="请输入手机号码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性别" prop="sex">
                                <el-select v-model="editData.sex" placeholder="请选择" class="select-box">
                                    <el-option label="男" value="1"></el-option>
                                    <el-option label="女" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="会员等级" prop="vip_id">
                                <el-select v-model="editData.vip_id" placeholder="请选择" class="select-box">
                                    <el-option label="无" :value="''"></el-option>
                                    <el-option v-for="(vip, key) in vip_list" :key="key" :label="vip.vip_name" :value="vip.vip_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="isManager || isAdd">
                            <el-form-item label="消费密码" prop="new_password">
                                <el-input v-model="editData.new_password" :placeholder="editData.pay_password ? '******' : '请输入消费时的支付密码'"
                                          type="password" :showPassword="!isAdd"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="isAdd">
                            <el-form-item label="确认密码" prop="repeat_password">
                                <el-input v-model="editData.repeat_password" :placeholder="editData.pay_password ? '******' : '再次输入消费时的支付密码'" type="password"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="姓名编码" prop="name_spell" :rules='[
                                {required: true, message: "请填写姓名编码"},
                            ]'>
                                <el-input v-model="editData.name_spell" placeholder="请输入会员姓名编码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="会员卡号" prop="no">
                                <el-input v-model="editData.no" placeholder="请输入会员卡号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="有效时间">
                                <el-date-picker
                                        v-model="editData.vip_expire"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        class="select-box"
                                        placeholder="不输入为永久有效">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="isAdd">
                            <el-form-item label="会员费" prop="join_price">
                                <el-input v-model="editData.join_price" placeholder="不收会员费则不输入" />
                                <!--<el-checkbox v-model="editData.is_user_money">当余额使用</el-checkbox>-->
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="生日类型" prop="birthday_type">
                                <el-select v-model="editData.birthday_type" placeholder="请选择" class="select-box">
                                    <el-option label="公历" value="1"></el-option>
                                    <el-option label="农历" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="生日日期" prop="birthday">
                                <el-date-picker type="date" placeholder="选择日期" v-model="editData.birthday" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="会员地址" prop="address">
                                <el-input v-model="editData.address" placeholder="请输入会员住址"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="备注" prop="remarks">
                                <el-input v-model="editData.remarks" placeholder="请输入会员备注信息"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="服务人员">
                                <el-button type="text" @click="selectStaffState = true">添加</el-button>
                                <span class="split-icon"></span>
                                <el-button type="text" @click="clearStaff">清空</el-button>
                            </el-form-item>
                            <div class="staff-box">
                                <el-table :data="staffListData" height="170" style="width: 100%" ref="selectTable" class="table-box-2" v-show="staffListData.length > 0">
                                    <el-table-column prop="work_id" label="工号" />
                                    <el-table-column prop="name" label="姓名" />
                                    <el-table-column label="操作">
                                        <template slot-scope="data">
                                            <el-button type="text" @click="deleteStaff(data.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <template v-slot:foot>
                <div class="foot">
                    <div class="attach-box" v-if="isAdd">
                        <el-button-group>
                            <el-button size="mini" @click="giveState = true">赠送</el-button>
                            <!--<el-button size="mini" @click="remarkState = true">备注</el-button>-->
                        </el-button-group>
                    </div>
                    <div class="btn-box">
                        <el-button size="medium" @click="close">&nbsp;&nbsp;关闭&nbsp;&nbsp;</el-button>
                        <el-button size="medium" type="primary" @click="editSubmit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                    </div>
                </div>
            </template>
        </pop-form>

        <!--提交结算-->
        <store-user-total-done v-model="totalState" :settleData="totalData" @settleOver="settleOver" />
        <!--赠送-->
        <cash-give v-model="giveState" :init-data="giveData" @submit="setGiveData" />
        <!--选择服务人员-->
        <CashStaffSelectBox v-model="selectStaffState" :pro-type="6" :selected-staff="staffListData" @selected="selectStaffEvent"/>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import StoreUserTotalDone from "@/model/StoreUser/StoreUserTotalDone";
    import CashGive from "@/model/Cash/CashGive";
    import CashStaffSelectBox from "@/model/Cash/CashStaffSelectBox";
    export default {
        name: "StoreUserEdit",
        components: {CashStaffSelectBox, CashGive, StoreUserTotalDone, PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: String,
                default: ""
            }
        },
        data: () => ({
            title: "",
            isAdd: true,
            isManager: false,
            oldEditData: {},
            editData: {
                id: "",
                no: "",
                vip_id: "",
                vip_expire: "",
                name: "",
                name_spell: "",
                mobile: "",
                sex: "1",
                pay_password: "",
                birthday_type: "1",
                birthday: "",
                address: "",
                remarks: "",
                join_price: "",
            },
            vip_list: [],

            //赠送
            giveState: false,
            giveData: null,

            //结算
            totalState: false,
            totalData: {},

            //服务人员
            selectStaffState: false,
            staffListData: []
        }),
        mounted: function () {
            if(this.$store.state.session.role == 1 || this.$store.state.session.role == 2)
                this.isManager = true;
        },
        methods: {
            //加载VIP列表
            loadVipList: function () {
                obj.postData("store_vip/get_vip_sort_list", {store_uid: this.storeUid}, res => {
                    if(res.errcode === 0)
                    this.vip_list = res.data;
                });
            }
            //加载会员信息
            ,loadStoreUserInfo: function () {
                if(obj.isEmpty(this.storeUid))
                    return ;

                obj.postData("store_user/get_store_user_info", {id: this.storeUid}, res => {
                    if(res.errcode === 0){
                        if(res.data.vip_id == 0)
                            res.data.vip_id = "";

                        this.editData = res.data;
                        this.title = "编辑" + res.data.mobile;
                    }
                });
            }
            //获取姓名编码
            ,getUserNameSpell: function () {
                if(obj.isEmpty(this.editData.name))
                    this.editData.name_spell = "";
                else {
                    obj.postData("store_user/get_user_name_spell", {name: this.editData.name}, res => {
                        if(res.errcode === 0) {
                            this.$set(this.editData, "name_spell", res.data);
                            this.$root.log(this.editData);
                        }
                    });
                }
            }
            //初始化数据
            ,init: function () {
                this.editData = {
                    id: "",
                    no: "",
                    vip_id: "",
                    vip_expire: "",
                    name: "",
                    name_spell: "",
                    mobile: "",
                    sex: "1",
                    pay_password: "",

                    birthday_type: "1",
                    birthday: "",
                    address: "",
                    remarks: "",
                    join_price: "",
                };
                this.giveData = null;
                this.staffListData = [];
                this.loadVipList();
            }
            //修改提交
            ,editSubmit: function () {
                this.$refs.editData.validate( d => {
                    if(!d) return ;

                    if(this.isAdd)
                        this.addEvent();
                    else
                        this.editEvent();
                });
            }
            //添加提交
            ,addEvent: function () {
                if(this.editData.new_password && this.editData.new_password !== this.editData.repeat_password){
                    obj.message.error("两次消费密码输入不一致");
                    return false;
                }

                this.totalData = {
                    no: this.editData.no,
                    name: this.editData.name,
                    mobile: this.editData.mobile,
                    sex: this.editData.sex,
                    vip_id: this.editData.vip_id,
                    vip_expire: this.editData.vip_expire ? this.editData.vip_expire : "",
                    pay_password: this.editData.new_password ? this.editData.new_password : "",
                    birthday_type: this.editData.birthday_type,
                    birthday: this.editData.birthday,
                    address: this.editData.address ? this.editData.address : "",
                    remarks: this.editData.remarks ? this.editData.remarks : "",
                    join_price: this.editData.join_price,
                    give_data: this.giveData,
                    staff: JSON.stringify(this.staffListData),
                };
                this.totalState = true;
            }
            //修改提交
            ,editEvent: function () {
                this.totalData = {
                    id: this.editData.id,
                    no: this.editData.no,
                    name: this.editData.name,
                    name_spell: this.editData.name_spell,
                    mobile: this.editData.mobile,
                    sex: this.editData.sex,
                    vip_id: this.editData.vip_id,
                    vip_expire: this.editData.vip_expire ? this.editData.vip_expire : "",
                    password: this.editData.new_password ? this.editData.new_password : "",
                    birthday_type: this.editData.birthday_type,
                    birthday: this.editData.birthday ? this.editData.birthday : "",
                    address: this.editData.address ? this.editData.address : "",
                    remarks: this.editData.remarks ? this.editData.remarks : "",
                    staff: JSON.stringify(this.staffListData),
                };
                this.totalState = true;
            }

            //关闭
            ,close: function () {
                this.$emit("showChange", false);
            }

            //结算成功
            ,settleOver: function () {
                obj.message.success(this.title + "成功");
                this.$emit("changeData", true);
                this.close();
            }

            //设置赠送数据
            ,setGiveData: function (giveData) {
                this.giveData = giveData;
            }

            //添加服务人员回调
            ,selectStaffEvent: function (staffList) {
                this.staffListData = staffList;
            }
            //删除指定服务人员
            ,deleteStaff: function (index) {
                this.staffListData.splice(index, 1);
            }
            //清空服务人员
            ,clearStaff: function () {
                this.staffListData = [];
            }
        },
        watch: {
            show: function (data) {
                if(data){
                    this.init();
                    if(obj.isEmpty(this.storeUid)) {
                        this.isAdd = true;
                        this.title = "添加会员";
                    }else {
                        this.isAdd = false;
                        this.title = "编辑";
                    }
                    this.loadStoreUserInfo();
                }else{
                    this.editData = {};
                }
            },
            "editData.name_spell": function (val) {
                if(typeof val === "string")
                    this.editData.name_spell = val.toLocaleUpperCase();
                else
                    this.editData.name_spell = "";
            }
        }
    }
</script>

<style scoped>
    .edit-box{
        padding-right: 30px;
    }
    .select-box{
        width: 100%;
    }
    .foot{
        padding: 0px 20px 10px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }
    .attach-box{
        flex: 1;
        text-align: left;
    }
    .btn-box{
        flex: 1;
        text-align: right;
    }
    .set-time-box{
        padding: 0px 32px 22px;
    }
    .set-time-box .sub-btn-box{
        float: right;
    }
    .set-time-box .date{
        width: 130px;
    }
    .vip_expire_data{
        margin-bottom: 10px;
    }
    .split-icon{
        width: 2px;
        height: 15px;
        background-color: #cccccc;
        display: inline-block;
        margin: 0px 9px -2px;
    }
    .staff-box{
        clear: both;
        min-height: 20px;
        padding-left: 10px;
    }
    .el-form-item{
        margin-bottom: 16px;
    }
</style>
